export default function initSliderDetailsPanel($){

    // This module is specific to the Smart Slider used on tour / exhibition
    // pages. Bail early on any page that doesn't have one — otherwise the
    // `syncDetailsButtonVisibility()` path below will call
    // `$(".button_details").hide()` globally and clobber the news-post
    // featured-image toggle (which reuses the same class name).
    if ($(".has-slider").length === 0) {
        return;
    }

    if ($(".native-tour-slider").length) {
        initNativeTourSliders($);
        return;
    }

    console.log('Initializing Slider Details Panel module');

    var tourWorksDetailsHeight = 0;
    var tourWorksSlideshowHeight = 0;
    var tourWorksHeight = 0;
    var baseSlideHeight = 0;
    var detailsObserver = null;

        function getActiveDetails() {
            var $activeDetails = $(".n2-ss-slide-active .work-details");
            if ($activeDetails.length === 0) {
                $activeDetails = $(".has-slider .work-details").first();
            }
            return $activeDetails;
        }

        function showActiveDetails() {
            var $activeDetails = getActiveDetails();
            $(".work-details").hide();
            $activeDetails.show();
            return $activeDetails;
        }

        function hideAllDetails() {
            $(".work-details").hide();
        }

        function activeDetailsHasContent() {
            var $activeDetails = getActiveDetails();
            if (!$activeDetails || $activeDetails.length === 0) {
                return false;
            }

            var detailsText = $activeDetails.text();
            return detailsText && detailsText.trim().length > 0;
        }

        function syncDetailsButtonVisibility() {
            var hasContent = activeDetailsHasContent();
            var $exhibitionFavourite = $(".exhibition-favourite");

            if (!hasContent) {
                $(".n2-ss-section-main-content").removeClass("show-details");
                hideAllDetails();
                $(".button_details").hide();
                $exhibitionFavourite.css("margin-left", "60px");
                return;
            }

            $(".button_details").show();
            $exhibitionFavourite.css("margin-left", "");
        }

        function refreshMeasurements() {
          console.log("Refreshing measurements for Slider Details Panel");
          var $activeDetails = getActiveDetails();
              if (!$(".n2-ss-section-main-content").hasClass("show-details")) {
                  baseSlideHeight = $(".has-slider .n2-ss-slide").height() || $(".has-slider").height() || 0;
              }
              tourWorksSlideshowHeight = baseSlideHeight || $(".has-slider").height() || 0;

              tourWorksDetailsHeight = measureDetailsHeight($activeDetails);
          tourWorksHeight = tourWorksSlideshowHeight + tourWorksDetailsHeight; // extra padding

          console.log("Tour Works Details Height: " + tourWorksDetailsHeight);
          console.log("Tour Works Slideshow Height: " + tourWorksSlideshowHeight);
          console.log("Total Tour Works Height: " + tourWorksHeight);

        if (detailsObserver) {
            detailsObserver.disconnect();
            detailsObserver = null;
        }

        if (window.ResizeObserver && $activeDetails.length) {
            detailsObserver = new ResizeObserver(function() {
                tourWorksDetailsHeight = measureDetailsHeight($activeDetails);
                tourWorksHeight = tourWorksSlideshowHeight + tourWorksDetailsHeight + 40; // extra padding
                applyCurrentState();
            });
            detailsObserver.observe($activeDetails.get(0));
        }
    }

    function measureDetailsHeight($details) {
        if (!$details || $details.length === 0) {
            return 0;
        }

        var wasHidden = $details.css("display") === "none";
        var prevVisibility = $details.css("visibility");
        var prevDisplay = $details.css("display");

        if (wasHidden) {
            $details.css({ visibility: "hidden", display: "block" });
        }

        var height = $details.outerHeight(true) || 0;

        if (wasHidden) {
            $details.css({ visibility: prevVisibility, display: prevDisplay });
        }

        return 30 + 0; // add some padding
    }

    function applyCurrentState() {
        if ($(".n2-ss-section-main-content").hasClass("show-details")) {
            $(".has-slider .n2-ss-slide").height(tourWorksHeight);
            // Tell CSS how tall the description panel is so the
            // .exhibition-favourite icon can compensate via
            // `bottom: calc(22px + var(--details-h, 0px))` and stay
            // pinned to the caption row instead of following the
            // expanded hero downward.
            $(".tour-hero").css("--details-h", tourWorksDetailsHeight + "px");
        } else {
            $(".has-slider .n2-ss-slide").height(tourWorksSlideshowHeight);
            $(".tour-hero").css("--details-h", "0px");
        }
    }

    function scheduleRefresh() {
        requestAnimationFrame(function() {
            syncDetailsButtonVisibility();
            refreshMeasurements();
            applyCurrentState();
        });
    }

    scheduleRefresh();
    setTimeout(scheduleRefresh, 100);

    $(".button_details").off("click.sliderDetails").on("click.sliderDetails", function(e){
        e.preventDefault();
        syncDetailsButtonVisibility();
        if (!activeDetailsHasContent()) {
            return;
        }
        refreshMeasurements();

        if ($(".n2-ss-section-main-content").hasClass("show-details")) {
            $(".n2-ss-section-main-content").removeClass("show-details");
            hideAllDetails();
            tourWorksSlideshowHeight = baseSlideHeight || $(".has-slider .n2-ss-slide").height() || $(".has-slider").height() || 0;
            // animate slide height back to original

            $(".has-slider .n2-ss-slide").animate({
                height: tourWorksSlideshowHeight + "px"
            }, 200);

            // Reset the favourite-icon offset that was set when the
            // description was opened (see CSS `--details-h` usage).
            $(".tour-hero").css("--details-h", "0px");

            $(".button_details .nfa").addClass("nfa-plus-circle");
            $(".button_details .nfa").removeClass("nfa-minus-circle");
            return;
        } else {
            baseSlideHeight = $(".has-slider .n2-ss-slide").height() || $(".has-slider").height() || 0;
            $(".n2-ss-section-main-content").addClass("show-details");
            refreshMeasurements();

            $(".has-slider .n2-ss-slide").animate({
                height: tourWorksHeight + "px"
            }, 200, function() {
                showActiveDetails();
            });

            // Pin the favourite icon to the caption row by offsetting
            // its `bottom` value upward by the description height (see
            // SCSS rule using `var(--details-h)`).
            $(".tour-hero").css("--details-h", tourWorksDetailsHeight + "px");

            $(".button_details .nfa").addClass("nfa-minus-circle");
            $(".button_details .nfa").removeClass("nfa-plus-circle");
        }
        // $(".n2-ss-section-main-content").addClass("show-details");
        // $(".tour-hero .n2-ss-slide").css("height", tourWorksHeight + "px");
    });

    function initNativeTourSliders($) {
        $(".native-tour-slider").each(function() {
            var $slider = $(this);
            var $slides = $slider.find("[data-native-tour-slide]");
            var $dots = $slider.find("[data-native-tour-dot]");
            var $caption = $slider.find("[data-native-tour-caption]");
            var $details = $slider.find("[data-native-tour-details]");
            var $detailsValue = $details.find(".work-detail-value");
            var $detailsToggle = $slider.find(".native-tour-slider__details-toggle");
            var currentIndex = 0;

            var $hero = $slider.closest(".tour-hero, .resource-hero, .news-hero");
            var $sliderFavourite = $hero.find(".exhibition-favourite, .resource-favourite");
            var $viewport = $slider.find(".native-tour-slider__viewport").first();

            function syncCaptionControlsPosition() {
                if ($caption.length === 0 || $viewport.length === 0) {
                    return;
                }

                var captionRect = $caption.get(0).getBoundingClientRect();
                var viewportRect = $viewport.get(0).getBoundingClientRect();

                if ($detailsToggle.length) {
                    var toggleHeight = $detailsToggle.outerHeight() || 40;
                    var toggleCenterOffset = captionRect.top - viewportRect.bottom + (captionRect.height / 2);
                    $detailsToggle.css("bottom", (0 - toggleCenterOffset - (toggleHeight / 2)) + "px");
                }

                if ($sliderFavourite.length && $hero.length) {
                    var heroRect = $hero.get(0).getBoundingClientRect();
                    var favouriteHeight = $sliderFavourite.outerHeight() || 24;
                    var favouriteTop = captionRect.top - heroRect.top + ((captionRect.height - favouriteHeight) / 2);
                    $sliderFavourite.css({
                        top: favouriteTop + "px",
                        bottom: "auto"
                    });
                }
            }

            // Measure after the slider has settled (images may load and
            // shift heights). Use both rAF and a small timeout so the icons
            // land on the caption row's centre.
            requestAnimationFrame(syncCaptionControlsPosition);
            setTimeout(syncCaptionControlsPosition, 200);
            $(window).on("resize.nativeTourSlider", syncCaptionControlsPosition);
            $slider.find("img").on("load.nativeTourSlider", syncCaptionControlsPosition);

            function activeSlide() {
                return $slides.filter(".is-active").first();
            }

            function activeDescription() {
                return activeSlide().attr("data-description") || "";
            }

            function descriptionHasContent(description) {
                var text = $("<div>").html(description || "").text().replace(/\u00a0/g, " ");
                return $.trim(text).length > 0;
            }

            function closeDetails() {
                $slider.removeClass("show-details");
                $details.attr("hidden", true).hide();
                $detailsToggle.attr("aria-expanded", "false");
                $detailsToggle.find(".nfa").addClass("nfa-plus-circle").removeClass("nfa-minus-circle");
            }

            function syncDetailsButton() {
                var hasDescription = descriptionHasContent(activeDescription());
                if (!hasDescription) {
                    closeDetails();
                    $detailsToggle.hide();
                    return;
                }

                $detailsToggle.show();
            }

            function removeVideoEmbeds() {
                $slider.find(".slide-video-embed").remove();
                $slider.find(".slide-video-play").show();
            }

            function goToSlide(index) {
                if (index < 0 || index >= $slides.length || index === currentIndex) {
                    return;
                }

                currentIndex = index;
                removeVideoEmbeds();
                closeDetails();

                $slides.removeClass("is-active").attr("aria-hidden", "true");
                var $nextSlide = $slides.eq(index).addClass("is-active").attr("aria-hidden", "false");

                $dots.removeClass("is-active").attr("aria-current", "false");
                $dots.filter('[data-native-tour-dot="' + index + '"]').addClass("is-active").attr("aria-current", "true");

                $caption.html($nextSlide.attr("data-caption") || "");
                $detailsValue.html(activeDescription());
                syncDetailsButton();
                requestAnimationFrame(syncCaptionControlsPosition);
            }

            $dots.on("click.nativeTourSlider", function() {
                goToSlide(parseInt($(this).attr("data-native-tour-dot"), 10));
            });

            $detailsToggle.on("click.nativeTourSlider", function(e) {
                e.preventDefault();
                syncDetailsButton();

                if ($detailsToggle.is(":hidden")) {
                    return;
                }

                var shouldOpen = !$slider.hasClass("show-details");
                if (shouldOpen) {
                    $detailsValue.html(activeDescription());
                    $slider.addClass("show-details");
                    $details.removeAttr("hidden").stop(true, true).slideDown(200);
                    $detailsToggle.attr("aria-expanded", "true");
                    $detailsToggle.find(".nfa").addClass("nfa-minus-circle").removeClass("nfa-plus-circle");
                    return;
                }

                $details.stop(true, true).slideUp(200, function() {
                    closeDetails();
                });
            });

            $slider.find(".slide-video-play").on("click.nativeTourSlider", function(e) {
                e.preventDefault();
                e.stopPropagation();

                var embedUrl = getVideoEmbedUrl($(this).attr("data-video-url"));
                if (!embedUrl) {
                    return;
                }

                var $slide = $(this).closest("[data-native-tour-slide]");
                var $embed = $('<div class="slide-video-embed"><iframe src="' + embedUrl + '" allow="autoplay; encrypted-media; fullscreen" allowfullscreen></iframe></div>');
                $slide.append($embed);
                $(this).hide();
            });

            $details.hide();
            syncDetailsButton();
        });
    }

    // ── Video play button logic for exhibition slides ──
    function getVideoEmbedUrl(url) {
        if (!url) return null;
        var ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([\w-]+)/);
        if (ytMatch) return 'https://www.youtube.com/embed/' + ytMatch[1] + '?autoplay=1&rel=0';
        var vimeoMatch = url.match(/(?:vimeo\.com\/)(\d+)/);
        if (vimeoMatch) return 'https://player.vimeo.com/video/' + vimeoMatch[1] + '?autoplay=1';
        return null;
    }

    function initVideoPlayButtons() {
        $(".slide-video-wrap[data-video-url]").each(function() {
            var $wrap = $(this);
            var $slide = $wrap.closest(".n2-ss-slide");
            if ($slide.find(".slide-video-play").length) return; // already initialised

            var videoUrl = $wrap.data("video-url");
            var embedUrl = getVideoEmbedUrl(videoUrl);
            if (!embedUrl) return;

            var $btn = $('<button type="button" class="slide-video-play" aria-label="Play video"></button>');
            // Append to the slide's background/image container
            var $imgContainer = $slide.find(".n2-ss-section-main-content");
            if (!$imgContainer.length) $imgContainer = $slide;
            $imgContainer.css("position", "relative").append($btn);

            $btn.on("click", function(e) {
                e.preventDefault();
                e.stopPropagation();
                var $embed = $('<div class="slide-video-embed"><iframe src="' + embedUrl + '" allow="autoplay; encrypted-media; fullscreen" allowfullscreen></iframe></div>');
                $imgContainer.append($embed);
                $btn.hide();
            });
        });
    }

    // Run on initial load and after Smart Slider renders
    setTimeout(initVideoPlayButtons, 200);
    setTimeout(initVideoPlayButtons, 1000);

    var $slider = $(".has-slider .n2-ss-slider");
    if ($slider.length) {
        $slider
            .off("CurrentSlideChanged.sliderDetails mainAnimationComplete.sliderDetails BeforeShow.sliderDetails SliderResize.sliderDetails")
            .on("BeforeShow.sliderDetails SliderResize.sliderDetails", function() {
                scheduleRefresh();
            })
            .on("CurrentSlideChanged.sliderDetails mainAnimationComplete.sliderDetails", function() {
                $(".n2-ss-section-main-content").removeClass("show-details");
                hideAllDetails();
                baseSlideHeight = $(".has-slider .n2-ss-slide").height() || $(".has-slider").height() || 0;
                $(".button_details .nfa").addClass("nfa-plus-circle");
                $(".button_details .nfa").removeClass("nfa-minus-circle");
                $(".has-slider .n2-ss-slide").stop(true, true).height(tourWorksSlideshowHeight);
                // Remove any playing video embeds and restore play buttons
                $(".slide-video-embed").remove();
                $(".slide-video-play").show();
                syncDetailsButtonVisibility();
                scheduleRefresh();
                initVideoPlayButtons();
            });
    }



}
